import { takeEvery, fork, delay, put, all, call } from "redux-saga/effects"
import {
  addPolicyTypeAPI,
  viewPolicyTypeAPI,
  addPolicyCustomerAPI,
  getPolicyCustomerAPI,
  getPolicyCustomerByIDAPI,
  updatePolicyCustomerAPI,
  GetAllCompaniesAPI,
  GetAllSubLOBAPI,
  GetAllLOBAPI,
  GetAllPolicyTypesAPI,
  PolicyLinkingAPI,
  ProductName,
  GstAPI,
  AdditionalFieldNameAPI,
  GetSTATEAPI,
  GetRegistationNumAPI,
  GetBrandAPI,
  GetModelNameAPI,
  GetPolicyReportAPI,
  GetReferencesAPI,
  DuplicatePolicyNumberAPI,
  AddVehicleMakeModeAPI,
  DeletePolicyAPI,
  reqPolicyReportAPI,
  PolicyReportStatusAPI,
  downloadPolicyReportAPI,
  getAllPolicyReportsAPI,
  getCommissionPermissionAPI,
  uploadPolicyFileAPI,
  getUploadPolicyFileAPI,
  deletePolicyFileAPI,
  editPolicyFilesAPI
} from "./api"

import {
  ADD_POLICY_TYPE_START,
  VIEW_POLICY_TYPE_START,
  ADD_POLICY_START,
  GET_POLICY_CUSTOMER_START,
  GET_POLICY_CUSTOMER_ID_START,
  UPDATE_POLICY_START,
  GET_Company_START,
  GET_POLICY_START,
  GET_SUB_POLICY_START,
  POLICY_LINKING_START,
  GET_SUB_LOB_START,
  GET_GST_START,
  GET_RRODUCT_START,
  GetAdditionalLOB_START,
  GET_ENUM_VALUE,
  GET_STATE_START,
  GET_BRAND_START,
  GET_MODEL_START,
  GET_REG_START,
  GET_POLICYREPORT_START,
  GET_REFERENCES_START,
  CHECK_POLICY_NUMBER_START,
  ADD_MAKE_MODEL_START,
  DELETE_POLICY_START,
  REQ_POLICY_REPORT,
  POLICY_REPORT_STATUS,
  DOWNLOAD_POLICY_REPORT,
  GET_ALL_POLICY_REPORTS,
  UPLOAD_POLICY_FILE_START,
  GET_UPLOADED_POLICY_FILE_START,
  DELETE_POLICY_FILE_START,
  EDIT_POLICY_FILES,
  GET_COMMISSION_PERMISSION
} from "./constant"

import {
  addPolicyTypeFailure,
  addPolicyTypeSuccess,
  viewPolicyTypeSuccess,
  viewPolicyTypeFailure,
  addPolicySuccess,
  addPolicyFailure,
  getPolicySuccess,
  getPolicyFailure,
  getPolicyIdSuccess,
  getPolicyIdFailure,
  updatePolicySuccess,
  updatePolicyFailure,
  getCompanySuccess,
  getCompanyFailure,
  getPolicyNameSuccess,
  getPolicyNameFailure,
  getSubPolicyNameSuccess,
  getSubPolicyNameFailure,
  PolicyLinkingSuccess,
  PolicyLinkingFailure,
  getSubLobSuccess,
  getSubLobFailure,
  getProductNameFailure,
  getProductNameSuccess,
  getGSTSuccess,
  getGSTFailure,
  getAdditionalLobSuccess,
  getAdditionalLobFailure,
  getEnumValueSuccess,
  getStateSuccess,
  getStateFailure,
  getRegSuccess,
  getRegFailure,
  getBrandSuccess,
  getBrandFailure,
  getModelSuccess,
  getModelFailure,
  getPolicyReportSuccess,
  getReferecesSuccess,
  getReferecesFail,
  getPolicyReportFail,
  checkPolicyNumberSuccess,
  checkPolicyNumberFailure,
  AddVehicleMakeModelSuccess,
  AddVehicleMakeModelFailure,
  deletePolicyFailure,
  deletePolicySuccess,
  reqPolicyReportSuccess,
  reqPolicyReportFailed,
  getpolicyReportStatusSuccess,
  getpolicyReportStatusFailed,
  downloadPolicyReportSuccess,
  downloadPolicyReportFailed,
  getAllPolicyReportsSuccess,
  getAllPolicyReportsFailed,
  getCommissionPermissionSuccess,
  getCommissionPermissionFailed,
  uploadFileSuccess,
  uploadFileFail,
  getUploadedFileSuccess,
  getUploadedFileFailure,
  deleteFileSuccess,
  deleteFileFailure,
  editPolicyFilesSuccess,
  editPolicyFilesFailed
} from "./action"

function* Policy() {
  // Expired Policy Linking Feature

  function* PolicyLinkingAsync(action) {
    try {
      const response = yield call(PolicyLinkingAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(PolicyLinkingSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(PolicyLinkingFailure(error))
    }
  }

  function* PolicyLinking() {
    yield takeEvery(POLICY_LINKING_START, PolicyLinkingAsync)
  }

  // Add Policy Type
  function* AddPolicyAsync(action) {
    try {
      const response = yield call(addPolicyTypeAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(addPolicyTypeSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(addPolicyTypeFailure(error))
    }
  }

  function* AddPolicy() {
    yield takeEvery(ADD_POLICY_TYPE_START, AddPolicyAsync)
  }

  // view-Policy

  function* viewPolicyAsync() {
    try {
      const response = yield call(viewPolicyTypeAPI)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(viewPolicyTypeSuccess(response.data.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(viewPolicyTypeFailure(error))
    }
  }

  function* viewPolicy() {
    yield takeEvery(VIEW_POLICY_TYPE_START, viewPolicyAsync)
  }

  //

  function* AddPolicyCustomerAsync(action) {
    try {
      const response = yield call(addPolicyCustomerAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(addPolicySuccess(response.data))
      } else {
        yield put(addPolicyFailure(response.data.message))
      }
    } catch (error) {
      console.log(error.response.data.message)
      yield put(addPolicyFailure(error.response.data.message))
    }
  }

  function* AddPolicyCustomer() {
    yield takeEvery(ADD_POLICY_START, AddPolicyCustomerAsync)
  }

  // get policy for customer
  function* getPolicyAsync(action) {
    try {
      const response = yield call(getPolicyCustomerAPI, action.payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getPolicySuccess(response.data.data))
      } else {
        throw (response.data)
      }
    } catch (error) {
      yield put(getPolicyFailure(error.response.data))
    }
  }

  function* getPolicy() {
    yield takeEvery(GET_POLICY_CUSTOMER_START, getPolicyAsync)
  }

  // get policy by id for customer
  function* getPolicyByIDAsync(action) {
    try {
      const response = yield call(getPolicyCustomerByIDAPI, action.payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getPolicyIdSuccess(response.data.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getPolicyIdFailure(error))
    }
  }

  function* getPolicyByID() {
    yield takeEvery(GET_POLICY_CUSTOMER_ID_START, getPolicyByIDAsync)
  }

  // Update policy

  function* UpdatePolicyAsync(action) {
    try {
      const response = yield call(updatePolicyCustomerAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(updatePolicySuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(updatePolicyFailure(error))
    }
  }

  function* updatePolicy() {
    yield takeEvery(UPDATE_POLICY_START, UpdatePolicyAsync)
  }

  function* getCompanyAsync(action) {
    try {
      const response = yield call(
        GetAllCompaniesAPI,
        action.payload.insurancetype_id
      )
      if (response.status === 200 || 201) {
        delay(200)
        yield put(getCompanySuccess(response.data.data))
      } else {
        yield put(getCompanyFailure(response.data))
      }
    } catch (error) {
      yield put(getCompanyFailure(error))
    }
  }

  function* companyName() {
    yield takeEvery(GET_Company_START, getCompanyAsync)
  }

  // get Policy name
  function* getPolicyNameAsync() {
    try {
      const response = yield call(GetAllPolicyTypesAPI)
      if (response.status === 200 || 201) {
        delay(200)
        yield put(getPolicyNameSuccess(response.data.data))
      } else {
        yield put(getPolicyNameFailure(response.data))
      }
    } catch (error) {
      yield put(getPolicyNameFailure(response.data.error))
    }
  }

  function* getPolicyName() {
    yield takeEvery(GET_POLICY_START, getPolicyNameAsync)
  }

  // get sub-policy name
  function* getSubPolicyNameAsync(data) {
    try {
      const response = yield call(GetAllLOBAPI, data.payload)
      if (response.status === 200 || 201) {
        delay(200)
        yield put(getSubPolicyNameSuccess(response.data.data))
      } else {
        yield put(getSubPolicyNameFailure(response.data))
      }
    } catch (error) {
      yield put(getSubPolicyNameFailure(response.data.error))
    }
  }

  function* getSubPolicyName() {
    yield takeEvery(GET_SUB_POLICY_START, getSubPolicyNameAsync)
  }

  // get sub-lob insurance
  function* getSubLobAsync(action) {
    try {
      const response = yield call(GetAllSubLOBAPI, action.payload)
      if (response.status === 200 || 201) {
        delay(200)
        yield put(getSubLobSuccess(response.data.data))
      } else {
        yield put(getSubLobFailure(response.data))
      }
    } catch (error) {
      yield put(getSubLobFailure(response.data.error))
    }
  }

  function* getSubLobName() {
    yield takeEvery(GET_SUB_LOB_START, getSubLobAsync)
  }

  // Add Policy Type
  function* ProductAsync(action) {
    try {
      const response = yield call(ProductName, action.payload)
      if (response.status === 200 || 201) {
        yield put(getProductNameSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getProductNameFailure(error))
    }
  }

  function* Product() {
    yield takeEvery(GET_RRODUCT_START, ProductAsync)
  }

  // gst api

  function* GstAPIAsync() {
    try {
      const response = yield call(GstAPI)
      if (response.status === 200 || 201) {
        yield put(getGSTSuccess(response.data?.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getGSTFailure(error))
    }
  }

  function* GetGstAPI() {
    yield takeEvery(GET_GST_START, GstAPIAsync)
  }

  // Get Additional LOB Fields
  function* GetAdditionalFieldAsync(action) {
    try {
      const response = yield call(AdditionalFieldNameAPI, action.payload)
      if (response.status === 200 || 201) {
        delay(500)

        yield put(getAdditionalLobSuccess(response.data.data))
        yield put(getEnumValueSuccess(response.data.enumValues)) //)
      } else {
        throw response
      }
    } catch (error) {
      yield put(getAdditionalLobFailure(error))
    }
  }

  function* GetAdditionalField() {
    yield takeEvery(GetAdditionalLOB_START, GetAdditionalFieldAsync)
  }

  // GET STATE API

  function* GetStateAsync() {
    try {
      const response = yield call(GetSTATEAPI)
      if (response.status === 200 || 201) {
        yield put(getStateSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getStateFailure(error))
    }
  }

  function* GetStateFunc() {
    yield takeEvery(GET_STATE_START, GetStateAsync)
  }

  // GET REG :
  function* GetREGAsync(action) {
    try {
      const response = yield call(GetRegistationNumAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(getRegSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getRegFailure(error))
    }
  }

  function* GetREGFunc() {
    yield takeEvery(GET_REG_START, GetREGAsync)
  }

  // Brand Name
  function* GetBrandAsync() {
    try {
      const response = yield call(GetBrandAPI)
      if (response.status === 200 || 201) {
        yield put(getBrandSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getBrandFailure(error))
    }
  }

  function* GetBrandFunc() {
    yield takeEvery(GET_BRAND_START, GetBrandAsync)
  }

  // Model Name
  function* GetModelAsync(action) {
    try {
      const response = yield call(GetModelNameAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(getModelSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getModelFailure(error))
    }
  }

  function* GetModelFunc() {
    yield takeEvery(GET_MODEL_START, GetModelAsync)
  }

  function* GetPolicyReportsAsync(action) {
    try {
      const response = yield call(GetPolicyReportAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(getPolicyReportSuccess(response.data))
      } else {
        throw put(getPolicyReportFail(response.data.message))
      }
    } catch (error) {
      yield put(getPolicyReportFail(error.response.data.message))
    }
  }

  function* GetPolicyReports() {
    yield takeEvery(GET_POLICYREPORT_START, GetPolicyReportsAsync)
  }

  function* GetReferencesAsync(action) {
    try {
      const response = yield call(GetReferencesAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(getReferecesSuccess(response.data.data))
      } else {
        throw put(getReferecesFail(response.data.error))
      }
    } catch (error) {
      yield put(getReferecesFail(error.response.data.error))
    }
  }

  function* GetReferences() {
    yield takeEvery(GET_REFERENCES_START, GetReferencesAsync)
  }

  // check duplicate policy number
  function* CheckDuplicatePolicyNumberAsync(action) {
    try {
      const response = yield call(DuplicatePolicyNumberAPI, action.payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(checkPolicyNumberSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(checkPolicyNumberFailure(error))
    }
  }

  function* CheckDuplicatePolicyNumber() {
    yield takeEvery(CHECK_POLICY_NUMBER_START, CheckDuplicatePolicyNumberAsync)
  }

  // Vehicle Make and Vehicle Model
  function* AddMakeModelAsync(action) {
    try {
      const response = yield call(AddVehicleMakeModeAPI, action.payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(AddVehicleMakeModelSuccess(response.data.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(AddVehicleMakeModelFailure(error))
    }
  }

  function* AddMakeModel() {
    yield takeEvery(ADD_MAKE_MODEL_START, AddMakeModelAsync)
  }

  // Delete policy
  function* DeletePolicyAsync(action) {
    try {
      const response = yield call(DeletePolicyAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(deletePolicySuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(deletePolicyFailure(error))
    }
  }

  function* DeletePolicy() {
    yield takeEvery(DELETE_POLICY_START, DeletePolicyAsync)
  }

  // Requeset policy report
  function* RequestPolicyReportAsync(action) {
    try {
      const response = yield call(reqPolicyReportAPI, action.payload)
      if (response.status === 200 || 201) {
        yield put(reqPolicyReportSuccess(response?.data?.requestId || null))
      } else {
        throw response
      }
    } catch (error) {
      yield put(reqPolicyReportFailed(error))
    }
  }

  function* RequestPolicyReport() {
    yield takeEvery(REQ_POLICY_REPORT, RequestPolicyReportAsync)
  }




  // Requeset policy report
  function* policyReportStatusAsync(action) {
    try {
      const response = yield call(PolicyReportStatusAPI, action.payload)
      if (response.status === 200 || 201) {
        console.log(response?.data?.data?.status)
        yield put(getpolicyReportStatusSuccess(response?.data?.data?.status || null))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getpolicyReportStatusFailed(error))
    }
  }

  function* policyReportStatus() {
    yield takeEvery(POLICY_REPORT_STATUS, policyReportStatusAsync)
  }



  function* downloadPolicyReportAsync(action) {
    try {
      const response = yield call(downloadPolicyReportAPI, action.payload)
      if (response.status === 200 || 201) {
        console.log("download saga")
        yield put(downloadPolicyReportSuccess(response?.data?.downloadUrl || null))
      } else {
        throw response
      }
    } catch (error) {
      yield put(downloadPolicyReportFailed(error))
    }
  }

  function* downloadPolicyReport() {
    yield takeEvery(DOWNLOAD_POLICY_REPORT, downloadPolicyReportAsync)
  }


  function* getAllPolicyReportAsync() {
    try {
      const response = yield call(getAllPolicyReportsAPI)
      if (response.status === 200 || 201) {
        yield put(getAllPolicyReportsSuccess(response?.data?.data || []))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getAllPolicyReportsFailed("Someting Went wrong please try again"))
    }
  }

  function* getAllPolicyReport() {
    yield takeEvery(GET_ALL_POLICY_REPORTS, getAllPolicyReportAsync)
  }

  function* uploadPolicyFileAsync(action){
    try {
      const response = yield call(uploadPolicyFileAPI, action.payload)
      // console.log(response)
      if(response.status === 200 || 201){
        yield put(uploadFileSuccess(response.data.message))
      }else{
        throw response;
      }
    } catch (error) {
      console.log(error)
      yield put(uploadFileFail(error.response.data.message))
    }
  }
  
  function* uploadPolicyFiles(){
    yield takeEvery(UPLOAD_POLICY_FILE_START, uploadPolicyFileAsync)
  }
  
  function* getUploadedPolicyFilesAsync(action){
    try {
      const response = yield call(getUploadPolicyFileAPI, action.payload)
      // console.log(response)
      if(response.status === 200 || 201){
        yield put(getUploadedFileSuccess(response.data))
      }else{
        throw response;
      }
    } catch (error) {
      yield put(getUploadedFileFailure(error.response.data.message))
    }
  }
  
  function* getUploadedPolicyFiles(){
    yield takeEvery(GET_UPLOADED_POLICY_FILE_START, getUploadedPolicyFilesAsync)
  }
  

  function* deletePolicyFileAsync(action) {
    console.log(action.payload)
    try {
      const response = yield call(deletePolicyFileAPI, action.payload)
      if (response.status === 200) {
        yield put(deleteFileSuccess(response.data))
      } else {
        throw new Error(Response)
      }
    } catch (error) {
      yield put(deleteFileFailure(error.response.data))
    }
  }
  
  function* DeleteFile() {
    yield takeEvery(DELETE_POLICY_FILE_START, deletePolicyFileAsync)
  }

  function* editPolicyFilesAsync(action) {
    console.log(action.payload)
    try {
      const response = yield call(editPolicyFilesAPI, action.payload)
      if (response.status === 200) {
        yield put(editPolicyFilesSuccess(response.data))
      } else {
        throw new Error(Response)
      }
    } catch (error) {
      yield put(editPolicyFilesFailed(error?.response?.data.message||"Something unexpected error occured, please try again"))
    }
  }
  
  function* editCustFiles() {
    yield takeEvery(EDIT_POLICY_FILES, editPolicyFilesAsync)
  }



  function* getCommissionPermissionAsync() {
    try {
      const response = yield call(getCommissionPermissionAPI)
      if (response.status === 200 || 201) {
        yield put(getCommissionPermissionSuccess(response?.data || {
          "canEditCommission": false,
          "canViewCommission": false
        }))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getCommissionPermissionFailed("Someting Went wrong please try again"))
    }
  }

  function* getCommissionPermission() {
    yield takeEvery(GET_COMMISSION_PERMISSION, getCommissionPermissionAsync)
  }

  yield all([
    fork(AddPolicy),
    fork(viewPolicy),
    fork(AddPolicyCustomer),
    fork(getPolicy),
    fork(getPolicyByID),
    fork(updatePolicy),
    fork(companyName),
    fork(getPolicyName),
    fork(getSubPolicyName),
    fork(PolicyLinking),
    fork(getSubLobName),
    fork(Product),
    fork(GetGstAPI),
    fork(GetAdditionalField),
    fork(GetStateFunc),
    fork(GetREGFunc),
    fork(GetBrandFunc),
    fork(GetModelFunc),
    fork(GetPolicyReports),
    fork(GetReferences),
    fork(CheckDuplicatePolicyNumber),
    fork(AddMakeModel),
    fork(DeletePolicy),
    fork(RequestPolicyReport),
    fork(policyReportStatus),
    fork(downloadPolicyReport),
    fork(getAllPolicyReport),
    fork(uploadPolicyFiles),
    fork(getUploadedPolicyFiles),
    fork(DeleteFile),
    fork(editCustFiles),
    fork(getCommissionPermission),
  ])
}

export default Policy
